import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getProfileCandidateRes } from "core/http/service/internalEvents/resTypes";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: getProfileCandidateRes;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: null,
};

const getProfileCandidateSlice = createSlice({
  name: "getProfileCandidate",
  initialState,
  reducers: {
    getProfileCandidateStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getProfileCandidateSuccess: (
      state,
      action: PayloadAction<{
        data: getProfileCandidateRes;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload.data;
    },
    getProfileCandidateFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = null;
    },
    resetProfileCandidate: (state) => {
      state = initialState;
    },
  },
});

export const {
  getProfileCandidateStart,
  getProfileCandidateSuccess,
  getProfileCandidateFailed,
  resetProfileCandidate,
} = getProfileCandidateSlice.actions;

export default getProfileCandidateSlice.reducer;
